import React, { useRef, useState } from 'react';
import SuccessPage from '../Success';
import ReCAPTCHA from 'react-google-recaptcha'
import { convertImagesToBase64 } from '../convertImagesToBase64';
import axios from 'axios';
import { Puff } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const StepFive = ({ setStep, step, clientDetails, formData, setFormData, ownerInfo }) => {
  const [uploadProgress,setUploadProgress]=useState(0)
  const [registrationCompleted, setRegistrationCompleted] = useState(false);
  const fileInputRef = useRef(null);
  const [base64Images, setBase64Images] = useState([]);
  const [captchaValue, setCaptchaValue] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const captchaReference = useRef(null)
  const apiUrl = process.env.REACT_APP_API_URL;

  const { clientkey, merchant_id } = useParams();
  const [loading, setLoading] = useState(false);
  // handle choose file
  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);

    // Convert files to base64 and pass to another component
    convertImagesToBase64(files).then((base64Strings) => {
      setBase64Images(base64Strings);
      setFormData((pre) => ({ ...pre, file: base64Strings }))
    });

  };
  // handle captcha
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);

  };

  const handleCheckbox = (e) => {
    setIsCheckboxChecked(e.target.checked)
  }
  // final step submit 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isCheckboxChecked){
      return toast.error("Terms and conditions required");
    }
    if(!captchaValue){
      return toast.error("Captcha is required");
    }
    try {
      let data = {
        "file": base64Images,
        merchant_id,
        step: 5,
      }
      let dataAfterclean = formData?.ownership_detail?.reduce((acc, item, ind) => {
        acc[`OwnerInfo${ind >0 ? ind+1:""}`] = {
          ...item,
        
        };
        return acc;
      }, {});
      let deletedata={...formData}
      delete deletedata.ownership_detail
      delete deletedata.bussiness_to_business
      delete deletedata.bussiness_to_consumer
      // delete deletedata.dba
      let finalData = { ...deletedata,...dataAfterclean }
      setLoading(true);
      const response = await axios.post(
        `${apiUrl}/merchant/onboarding/${clientkey}`, merchant_id ? data : finalData, {
        headers: {
          'Content-Type': 'application/json',
        },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
      });
      if (response?.data?.result) {
        toast.success(response?.data?.message);
        setRegistrationCompleted(true);

      }
      else {
        toast.error(response?.data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Something went wrong");
      console.log(error);
    }
  }
// 
// console.log("===============files+================",selectedFiles);
// remove selected file
  const handleRemoveSelectedFile=(id)=>{
    const files=selectedFiles?.filter((item,ind)=>ind !==id)
    setSelectedFiles(files)
    
  }
  return (
    <div className="">
      <div className='client-logo'>
        <img src={clientDetails?.logo} alt='logo' />
      </div>
          {registrationCompleted ?
            <SuccessPage setStep={setStep}  /> :
      <div className='row'>
        <div className="container all-steps ">
                <div className="heading-container">
                  <div className='heading-text'>
                    <h2>Privacy policy, Terms & Conditions</h2>
                    <h5>Please upload the previous 3-Months processing statements and voided check</h5>
                  </div>
                  <div className='heading-ico'>
                    <img src="/privacy-terms.png" />
                  </div>
                </div>
            <div>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                </div>
                <div className='chooseFile' onClick={handleChooseFile} >
                  <div>
                    <input
                      type="file"
                      multiple
                      id="fileInput"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                    <label className="file-label" ><img src='/choose-file.png' /></label>

                    Drag and drop file here or <small>choose file</small>
                  </div>
                </div>
                <div>
                  <span className="file-name file-name-sec">{selectedFiles.length > 0 ? <span className="file-name">
                    {selectedFiles?.map((file, index) => (
                      <span key={index}><div> <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.96866 2.62966e-07L12.6662 4.86483e-07C12.8653 4.86483e-07 13.0558 0.0824317 13.1942 0.228434L18.7933 6.13468C18.9259 6.27456 19 6.4616 19 6.65625V18.781C19 19.5423 19 20.1577 18.9614 20.6564C18.9216 21.1698 18.8375 21.6241 18.6336 22.046C18.3109 22.7143 17.7935 23.2622 17.1518 23.6071C16.7437 23.8264 16.3043 23.9166 15.8123 23.959C15.3367 24 14.7508 24 14.0314 24H5.96858C5.24918 24 4.6633 24 4.18768 23.959C3.69569 23.9166 3.2563 23.8264 2.8482 23.6071C2.20645 23.2622 1.68913 22.7143 1.36635 22.046C1.16254 21.6241 1.07838 21.1698 1.03861 20.6564C0.999987 20.1577 0.999993 19.5423 1 18.781V5.21903C0.999993 4.45774 0.999987 3.84231 1.03861 3.34364C1.07838 2.83017 1.16254 2.37593 1.36635 1.95397C1.68913 1.28573 2.20645 0.737836 2.8482 0.392909C3.2563 0.173566 3.69569 0.0833792 4.18768 0.0409773C4.66332 -1.59431e-05 5.24922 -8.67773e-06 5.96866 2.62966e-07ZM4.31129 1.53566C3.91408 1.56989 3.695 1.63298 3.53276 1.72018C3.17114 1.91454 2.8727 2.22716 2.68424 2.61734C2.59745 2.797 2.53631 3.03737 2.50343 3.46187C2.46992 3.89444 2.46939 4.45045 2.46939 5.25V18.75C2.46939 19.5496 2.46992 20.1056 2.50343 20.5381C2.53631 20.9626 2.59745 21.203 2.68424 21.3827C2.8727 21.7728 3.17114 22.0855 3.53276 22.2798C3.695 22.367 3.91408 22.4301 4.31129 22.4643C4.71782 22.4994 5.24152 22.5 6.00066 22.5H13.9993C14.7585 22.5 15.2822 22.4994 15.6887 22.4643C16.0859 22.4301 16.305 22.367 16.4672 22.2798C16.8289 22.0855 17.1273 21.7728 17.3158 21.3827C17.4025 21.203 17.4637 20.9626 17.4966 20.5381C17.5301 20.1056 17.5306 19.5496 17.5306 18.75V7.40625H16.048C15.4771 7.40626 15.003 7.40627 14.6163 7.37294C14.2132 7.3382 13.8396 7.26334 13.4886 7.07465C12.9472 6.78365 12.5114 6.32181 12.2398 5.75942C12.065 5.39762 11.9954 5.01284 11.9629 4.59316C11.9315 4.18825 11.9315 3.69083 11.9315 3.08636V1.5H6.00066C5.24152 1.5 4.71782 1.50062 4.31129 1.53566ZM13.4009 2.60348L16.5319 5.90625H16.079C15.4692 5.90625 15.0575 5.90563 14.7399 5.87825C14.4316 5.85168 14.2783 5.80393 14.1731 5.74738C13.9119 5.60695 13.695 5.38038 13.5577 5.09604C13.4999 4.97654 13.4533 4.80564 13.4277 4.47493C13.4015 4.13616 13.4009 3.69829 13.4009 3.05625V2.60348ZM4.73272 11.7188C4.73272 11.3045 5.06165 10.9688 5.46741 10.9688H11.3331C11.7389 10.9688 12.0678 11.3045 12.0678 11.7188C12.0678 12.133 11.7389 12.4688 11.3331 12.4688H5.46741C5.06165 12.4688 4.73272 12.133 4.73272 11.7188ZM4.73272 14.5313C4.73272 14.117 5.06165 13.7813 5.46741 13.7813H14.5326C14.9383 13.7813 15.2673 14.117 15.2673 14.5313C15.2673 14.9455 14.9383 15.2813 14.5326 15.2813H5.46741C5.06165 15.2813 4.73272 14.9455 4.73272 14.5313ZM4.73272 17.625C4.73272 17.2108 5.06165 16.875 5.46741 16.875H14.5326C14.9383 16.875 15.2673 17.2108 15.2673 17.625C15.2673 18.0392 14.9383 18.375 14.5326 18.375H5.46741C5.06165 18.375 4.73272 18.0392 4.73272 17.625Z" fill="#35254D" />
                      </svg> {file.name} &nbsp;</div> <button type='button' onClick={()=>handleRemoveSelectedFile(index)}><svg width="19" height="19" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_8936_24656)">
                          <path d="M15.5 3.99998C15.5 3.54533 15.3173 3.10929 14.992 2.7878C14.6667 2.46631 14.2256 2.2857 13.7656 2.2857H11.453V1.71428C11.453 1.25962 11.2702 0.82359 10.9449 0.5021C10.6197 0.180611 10.1785 0 9.71851 0H6.24961C5.78961 0 5.34844 0.180611 5.02317 0.5021C4.6979 0.82359 4.51516 1.25962 4.51516 1.71428V2.2857H2.20257C1.79439 2.29312 1.40195 2.4426 1.09431 2.70784C0.786663 2.97308 0.583539 3.33707 0.520684 3.73575C0.45783 4.13444 0.539274 4.54226 0.750682 4.88743C0.96209 5.23261 1.28991 5.49302 1.67645 5.62283L2.67665 14.5199C2.73401 14.9309 2.94022 15.3074 3.25704 15.5795C3.57386 15.8517 3.97978 16.0011 4.39953 15.9999H11.5686C11.9903 16.0038 12.399 15.8557 12.7183 15.5833C13.0375 15.3109 13.2454 14.9329 13.303 14.5199L14.3032 5.62283C14.65 5.51107 14.9524 5.29409 15.1672 5.00274C15.3821 4.71139 15.4985 4.36051 15.5 3.99998ZM5.67146 1.71428C5.67146 1.56273 5.73237 1.41738 5.8408 1.31022C5.94922 1.20306 6.09628 1.14285 6.24961 1.14285H9.71851C9.87184 1.14285 10.0189 1.20306 10.1273 1.31022C10.2357 1.41738 10.2967 1.56273 10.2967 1.71428V2.2857H5.67146V1.71428ZM12.141 14.3942C12.1151 14.5263 12.043 14.6451 11.9372 14.7298C11.8315 14.8144 11.6989 14.8595 11.5628 14.8571H4.39953C4.26346 14.8595 4.13088 14.8144 4.02512 14.7298C3.91937 14.6451 3.84722 14.5263 3.82138 14.3942L2.85009 5.71426H13.118L12.141 14.3942ZM13.7656 4.57141H2.20257C2.04923 4.57141 1.90218 4.5112 1.79375 4.40404C1.68533 4.29688 1.62442 4.15153 1.62442 3.99998C1.62442 3.84843 1.68533 3.70309 1.79375 3.59592C1.90218 3.48876 2.04923 3.42856 2.20257 3.42856H13.7656C13.9189 3.42856 14.0659 3.48876 14.1744 3.59592C14.2828 3.70309 14.3437 3.84843 14.3437 3.99998C14.3437 4.15153 14.2828 4.29688 14.1744 4.40404C14.0659 4.5112 13.9189 4.57141 13.7656 4.57141Z" fill="#867C94" />
                          <path d="M6.24958 13.1428C6.40291 13.1428 6.54996 13.0826 6.65839 12.9754C6.76681 12.8683 6.82772 12.7229 6.82772 12.5714V7.42854C6.82772 7.27699 6.76681 7.13164 6.65839 7.02448C6.54996 6.91731 6.40291 6.85711 6.24958 6.85711C6.09624 6.85711 5.94919 6.91731 5.84076 7.02448C5.73234 7.13164 5.67143 7.27699 5.67143 7.42854V12.5714C5.67143 12.7229 5.73234 12.8683 5.84076 12.9754C5.94919 13.0826 6.09624 13.1428 6.24958 13.1428Z" fill="#867C94" />
                          <path d="M9.71847 13.1428C9.87181 13.1428 10.0189 13.0826 10.1273 12.9754C10.2357 12.8683 10.2966 12.7229 10.2966 12.5714V7.42854C10.2966 7.27699 10.2357 7.13164 10.1273 7.02448C10.0189 6.91731 9.87181 6.85711 9.71847 6.85711C9.56514 6.85711 9.41808 6.91731 9.30966 7.02448C9.20123 7.13164 9.14032 7.27699 9.14032 7.42854V12.5714C9.14032 12.7229 9.20123 12.8683 9.30966 12.9754C9.41808 13.0826 9.56514 13.1428 9.71847 13.1428Z" fill="#867C94" />
                        </g>
                        <defs>
                          <clipPath id="clip0_8936_24656">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                        </button></span>
                    ))}
                  </span> : ''}  </span>
                  <div className='termsConditions'>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <input type="checkbox" id="agreeCheckbox" onClick={handleCheckbox} />
                      <label htmlFor="agreeCheckbox">I have read, understand and accept the <a href="https://www.fractalpay.com/terms-and-conditions">terms and conditions</a> and the <a href="https://www.fractalpay.com/privacy-policy">privacy policy</a>.</label>
                    </div>
                  </div>
                  <ReCAPTCHA
                    className="recaptcha-container"
                    sitekey="6Lc5yLcpAAAAAGmxkAx0XZEdkPNJ-NzQsA4XHuPs"
                    onChange={handleCaptchaChange}
                    ref={captchaReference}
                  />
                  {/* <p>{captchaStatus.message}</p> */}
                </div>

                <div className='Btn1div'>
                  <button className='PrevBtn' onClick={() => { setStep(step - 1) }}>Previous</button>

                  <button className='FirstPgBtn' type='submit'>Complete</button>

                </div>
              </form>
            </div>
        </div>

      </div>
            }
      {loading && (
        <div className="loader-container ">
          <>
            <div className="loader-background"></div> 
            <div className="loader-content">
              <Puff color="#ffffff" height={100} width={100} />
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default StepFive;
